import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect } from 'react'

import { useBookingContext } from '@providers/booking/booking_context'
import { MAX_WIDGET_SIZE } from '@shared/constants'
import { i18WithParams as t } from '@shared/locale'
import { Spacer } from 'components-ui/src/spacer/spacer'
import { useRedirectNoData } from 'hooks/use_redirect_no_data'
import type { TPetOffers } from '../types'
import { DatePicker } from './date_picker'
import { DatesViewer } from './dates_viewer'
import { getBookingDates } from './helper'

export const RequestDates = ({ groomOffer, checkProvider }: { groomOffer: TPetOffers; checkProvider: boolean }) => {
  const bookingCtx = useBookingContext()
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))
  const { startDate, maxDate, minDate } = getBookingDates(bookingCtx.state)

  // redirect to home if the state has invalid data
  useRedirectNoData()

  useEffect(() => {
    if (bookingCtx.state.currentState !== 'grooming') {
      bookingCtx.dispatch({ type: 'SET_SEARCH_STATE', payload: { value: 'grooming' } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingCtx.state.currentState])

  return (
    <Box sx={{ maxWidth: MAX_WIDGET_SIZE, margin: '0 auto' }}>
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px`,
          mb: 2,
          minHeight: '210px',
          overflow: 'hidden',
        }}
      >
        {checkProvider ? (
          <Typography variant="h5">
            {t('groomingWizard.selectDate.title', {
              petName: groomOffer.pet.name,
              groomer: groomOffer.resource?.displayName || '',
            })}
          </Typography>
        ) : (
          <Typography variant="h5">
            {t('groomingWizard.selectDate.title.date', { petName: groomOffer.pet.name })}
          </Typography>
        )}

        <Spacer height={2} />

        <Stack
          direction={{ sx: 'column', md: 'row' }}
          alignContent="start"
          spacing={3}
          sx={{
            // Hacky way to hide the weeks
            '.MuiDayPicker-weekContainer:has(button[data-current-week="false"])': {
              display: 'none',
            },
            '.MuiDayPicker-weekContainer:has(button:not([disabled])), .MuiDayPicker-weekContainer:has(button[data-current-week="true"])':
              {
                display: 'flex',
              },
            '.MuiPickersArrowSwitcher-spacer': {
              display: 'none',
            },
          }}
        >
          <DatePicker
            startDate={startDate}
            maxDate={maxDate}
            minDate={minDate}
            groomOffer={groomOffer}
            checkProvider={checkProvider}
          />
          <DatesViewer groomOffer={groomOffer} />
        </Stack>
      </Paper>
    </Box>
  )
}
